import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Input, Button, Grid, Select } from 'semantic-ui-react';
import { AutoSizer } from 'react-virtualized';
import PropTypes from 'prop-types';
import { clone, applySnapshot, getSnapshot, tryResolve } from 'mobx-state-tree';

class CollectionManager extends Component {
  state = {
    searchString: '',
    isFormOpen: false,
    selectedItem: null,
    clone: null
  }
  handleChangeFilter = (event, data) => this.setState({ filterValue: data.value })
  handleChangeSearch = event => this.setState({ searchString: event.target.value })
  handleClickAdd = () => {
    const { getNewItem } = this.props
    this.setState({ clone: getNewItem(), selectedItem: null, isFormOpen: true })
  }
  handleClickItem = ({ event, index, rowData }) => {
    if (this.props.onClickItem) {
      this.props.onClickItem(rowData)
    } else {
      this.setState({ clone: clone(rowData), selectedItem: rowData, isFormOpen: true })
    }
  }
  handleReplaceSelectedItem = (item) => {
    this.setState({ clone: clone(item), selectedItem: item })
  }
  handleSaveForm = () => {
    const { store, collectionName } = this.props
    const { selectedItem, clone } = this.state
    if (selectedItem) {
      applySnapshot(selectedItem, getSnapshot(clone))
      selectedItem.save()
    } else {
      store.setCollectionItemFromSnapshot(collectionName, getSnapshot(clone))
      const newModel = tryResolve(store[collectionName], clone.id)
      if (newModel) {
        this.setState({ selectedItem: newModel })
        newModel.save()
      } else {
        console.warn('Could not resolve newly added model', clone.id, collectionName)
      }
    }
  }
  handleCloseForm = () => this.setState({ isFormOpen: false })
  render() {
    const { addButtonText, searchPlaceholder, getItems, ListComponent, FormComponent, fixedHeight } = this.props
    const { searchString, filterValue, isFormOpen, clone } = this.state
    const items = getItems(searchString, filterValue)
    return (
      <div style={{ display: 'flex', flexFlow: 'column', flex: 1 }}>
        <FormComponent 
          isOpen={isFormOpen} 
          model={clone} 
          onSave={this.handleSaveForm}
          onClose={this.handleCloseForm} 
          replaceSelectedModel={this.handleReplaceSelectedItem}
        />
        <Grid stackable columns='equal'>
          <Grid.Column>
            <Input 
              fluid
              onChange={this.handleChangeSearch} 
              placeholder={searchPlaceholder || 'Search...'}
              value={searchString} 
            />
          </Grid.Column>
          {this.props.filterOptions && !this.props.noFilter &&
            <Grid.Column>
              <Select fluid placeholder='Filter' options={this.props.filterOptions} onChange={this.handleChangeFilter} />
            </Grid.Column>
          }
          {!this.props.noAdd &&
            <Grid.Column width={4}>
              <Button fluid primary onClick={this.handleClickAdd}>{addButtonText || 'Add Item'}</Button>
            </Grid.Column>
          }
        </Grid>
        <div style={{ flex: 1 }}>
          <AutoSizer>
            {({ height, width }) => (
              <ListComponent
                height={fixedHeight || height}
                width={width}
                items={items} 
                onClickItem={this.handleClickItem}
              />
            )}
          </AutoSizer>
        </div>
      </div>
    )
  }
}

CollectionManager.propTypes = {
  FormComponent: PropTypes.func.isRequired,
  ListComponent: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
  getNewItem: PropTypes.func.isRequired
}

export default inject('store')(observer(CollectionManager));


// WEBPACK FOOTER //
// ./src/components/common/CollectionManager.js